export default defineNuxtPlugin(() => {
  const { $bugsnag } = useNuxtApp()
  const { isProduction } = useUtils()
  const route = useRoute()
  const rootStore = useRootStore()
  const customerManager = useCustomerManager()
  const cart = useCart()

  if ($bugsnag) {
    $bugsnag.leaveCrumb('cart controller client plugin')
  }

  const cartId = useCookie('cartId', {
    secure: isProduction(),
    path: '/',
    sameSite: 'lax',
    maxAge: 315360000, // 10 years
  })

  // Get customer id from the url
  const customerId = route.query.customer?.toString()

  // If we have a customer id then attempt to set the active customer
  if (customerId) {
    // Attempt to set the active customer. This should only happen if a sales rep opened this tab
    // from the customer manager.
    customerManager.setActiveCustomer(customerId)
  }

  // If we have an active customer then we are on the customer tab
  // and shouldn't update the cartId cookie
  if (!customerManager.customer.value) {
    watch(
      () => cart.state.value.id,
      (newVal) => {
        cartId.value = newVal
      }
    )
  }

  // Get the third party state that we parsed from the server
  const thirdPartyPayload = useState<AddItemsRequest[] | undefined>('thirdPartyPayload')

  onNuxtReady(async () => {
    // The id of the cart we are trying to init.
    // Use the value from the cartId cookie
    // but if it doesn't exist then init the cart from the existing permId.
    let id = cartId.value || rootStore.permId

    // If we have a customer then use their cart id.
    if (customerManager.customer.value) id = customerManager.customer.value.cartId

    // Init the cart
    await cart.init(id)

    // If we have a third party state we need to add it to the cart
    if (thirdPartyPayload.value) {
      // addItem sets the cart state so we don't need to fetch the cart here
      await cart.addItems(thirdPartyPayload.value)

      // Clean up the third party payload state from the app.
      clearNuxtState('thirdPartyPayload')
    }
  })
})
